<template>
  <div
    class="h-screen w-screen flex items-center justify-center flex-col bg-black bg-opacity-50 fixed top-0 left-0 z-50"
  >
    <h2 class="text-white">Ups al parecer no tienes internet</h2>
    <p class="text-white">Revisa tu conexión a internet</p>
  </div>
</template>
